import Container from '@mui/material/Container';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { CommissionModelOptions } from '../../features/team';

const CommissionModelPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.COMMISSION_MODEL}>
    <Container
      sx={{
        px: {
          xs: 0, lg: 2, md: 2, sm: 2,
        },
      }}
      maxWidth={false}
    >
      <CommissionModelOptions />
    </Container>
  </PageHelmet>
);

export default CommissionModelPage;
